import { render, staticRenderFns } from "./SubScale.vue?vue&type=template&id=830b2ac6&scoped=true"
import script from "./SubScale.vue?vue&type=script&lang=js"
export * from "./SubScale.vue?vue&type=script&lang=js"
import style0 from "./SubScale.vue?vue&type=style&index=0&id=830b2ac6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830b2ac6",
  null
  
)

export default component.exports